import React from 'react';

function Badge({ label, color, dim }) {
  const bg = dim
    ? color.startsWith('#')
      ? `${color}20`
      : color
    : `${color}20`;
  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 8px',
      borderRadius: 4,
      fontSize: 11,
      fontWeight: 600,
      fontFamily: 'var(--font-mono)',
      letterSpacing: '0.04em',
      color: color,
      background: bg,
      border: `1px solid ${color}40`,
      textTransform: 'uppercase',
    }}>
      {label}
    </span>
  );
}

export default Badge;
